import { Button, Spacing, Text, Title } from '@vkontakte/vkui';
import React, { memo, useCallback, useEffect } from 'react';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import type { AsidePollProps, PollResult } from 'reactApp/ui/AsidePollModal/AsidePollModal.types';

import styles from './Result.css';

type ResultProps = Pick<AsidePollProps, 'displayResult' | 'onClose'> & {
    results: PollResult[];
};

export const Result = memo<ResultProps>(({ displayResult, results, onClose }) => {
    const { title, text, buttonText, image, onClick, onShow } = displayResult(results);

    useEffect(() => {
        onShow?.();
        emitAnalyticEvent(AnalyticEventNames.ASIDE_POLL_RESULTS_SHOW);
    }, []);

    const handleClick = useCallback(() => {
        onClick();
        onClose?.();
        emitAnalyticEvent(AnalyticEventNames.ASIDE_POLL_RESULTS_CLICK);
    }, [onClick]);

    return (
        <>
            <img src={image} alt={title} className={styles.image} height={160} />
            <div className={styles.content}>
                <Title level="1" Component="span">
                    {title}
                </Title>
                <Spacing size={8} />
                <Text>{text}</Text>
                <Spacing size={20} />
                <Button mode="primary" appearance="accent-invariable" size="l" onClick={handleClick}>
                    {buttonText}
                </Button>
            </div>
        </>
    );
});

Result.displayName = 'Result';
